import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseSiteToSiteVpn from '../../AbstractObjects/GatewayPlan/InnerPages/BaseSiteToSiteVpn';
import {BladesPolicy} from '../../../../api/DBSchema/Enums';

const pageSchema = PlanGetSchema.pages.siteToSiteVpn;
const pageId = pageSchema.pageId;

const firewallPageSchema = PlanGetSchema.pages.firewall;
const firewallPageId = firewallPageSchema.pageId;

function PlanSiteToSiteVpn({
    planObject,
    setPlanData,
    setEditorPageId
}) {

    const pageData = planObject[pageId];
    const isFirewallStrict = planObject[firewallPageId][firewallPageSchema.policy] === BladesPolicy.STRICT;
    
    return (
        <BaseSiteToSiteVpn
            pageData={pageData}
            setObjectData={setPlanData}
            setEditorPageId={setEditorPageId}
            isFirewallStrict={isFirewallStrict}
        />
    );
}

export default PlanSiteToSiteVpn;